// IMPORTANT NOTE: Keep in sync with
// apps\admin\src\app\lib\ManualInfractions\MessagePresets.ts

// ToDo: https://dev.azure.com/qualisflow/Platform/_workitems/edit/18396 - Simplify and Update Descriptions for Submission Issues to remove front-end control of these values.

export const SubmissionErrorsDescriptionFilters = [
  {
    text: 'Unable to extract some information due to a blurred photo. Please upload a better photo.',
    value:
      'Unable to extract some information due to a blurred photo. Please upload a better photo.'
  },
  {
    text: 'Unable to extract some information from the ticket. Please ensure the entire ticket is captured within the photo.',
    value:
      'Unable to extract some information from the ticket. Please ensure the entire ticket is captured within the photo.'
  },
  {
    text: 'This looks like a photo has been taken of another tablet or mobile device.',
    value:
      'This looks like a photo has been taken of another tablet or mobile device.'
  },
  {
    text: 'This looks like a photo has been taken of a truck.',
    value: 'This looks like a photo has been taken of a truck.'
  }
]
